import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import home1 from "../Assets/images/Internship (3).gif"
import home2 from "../Assets/images/Internship (4).gif"
import home3 from "../Assets/images/Internship (5).gif"
import "../Assets/styles/banner.css"
import  CarouselItem  from 'react-bootstrap/CarouselItem';

function Banner() {
  return (
    <Carousel data-bs-theme="light" className='yoo'>
      <CarouselItem className='no1'>
        <div className="container-lg confirm">
        <div className="row">
          <div className="col-lg-6 col-md=6 col-sm-12 banner-left" data-aos="fade-up" data-aos-duration="1000ms">
            <h1>Make Real Life Connections With IT</h1>
            <p>Find a lifetime technical cofounder for your startup at no liquid cost.</p>
            <button type="submit" className='default-btn'><a href="/start">Get Started</a></button>
          </div>
          <div className="col-lg-6 col-md=6 col-sm-12 banner-right" data-aos="fade-up-left" data-aos-duration="1000ms">
            <img src={home1} alt="home1"/>
          </div>
        </div>
        </div>
      </CarouselItem>
      <CarouselItem className='no2'>
        <div className="container confirm">
        <div className="row">
          <div className="col-lg-6 col-md=6 col-sm-12 banner-left" data-aos="fade-up" data-aos-duration="1000ms">
            <h1>Your Startup Wingman</h1>
            <p> We are not just developers, we are your partner in the journey to startup success, through the challenges, victories, and all that lies in between.</p>
            <button type="submit" className='default-btn'><a href="/start">Get Started</a></button>
          </div>
          <div className="col-lg-6 col-md=6 col-sm-12 banner-right" data-aos="fade-up-left" data-aos-duration="1000ms">
            <img src={home2} alt="home1"/>
          </div>
        </div>
        </div>
      </CarouselItem>
      <CarouselItem className='no3'>
        <div className="container confirm">
        <div className="row">
          <div className="col-lg-6 col-md=6 col-sm-12 banner-left" data-aos="fade-up" data-aos-duration="1000ms">
            <h1>Supercharge Your Startup Dreams</h1>
            <p>From idea inception to product launch, we provide the expertise, support, and flexibility needed to turn visions into successful Startup solutions. </p>
            <button type="submit" className='default-btn'><a href="/start">Get Started</a></button>
          </div>
          <div className="col-lg-6 col-md=6 col-sm-12 banner-right" data-aos="fade-up-left" data-aos-duration="1000ms">
            <img src={home3} alt="home1"/>
          </div>
        </div>
        </div>
      </CarouselItem>
     
    </Carousel>
  );
}

export default Banner;